module.exports = __webpack_public_path__ + "assets/icon-powerSource-powerDuo.788889e4.svg";